export default __webpack_public_path__ + "static/share-8a1d15bd40e0ccfea5a793f94fe63fd9.png";